var React = require('react');

function More (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.76904 12.0049C8.76904 11.3257 8.22314 10.7798 7.53125 10.7798C6.85205 10.7798 6.2998 11.3257 6.2998 12.0049C6.2998 12.6841 6.85205 13.23 7.53125 13.23C8.2168 13.23 8.76904 12.6841 8.76904 12.0049ZM13.2188 12.0049C13.2188 11.3257 12.6792 10.7798 12 10.7798C11.3208 10.7798 10.7749 11.3257 10.7749 12.0049C10.7749 12.6841 11.3208 13.23 12 13.23C12.6729 13.23 13.2188 12.6841 13.2188 12.0049ZM17.6938 12.0049C17.6938 11.3257 17.1479 10.7798 16.4688 10.7798C15.7769 10.7798 15.231 11.3257 15.231 12.0049C15.231 12.6841 15.7769 13.23 16.4688 13.23C17.1416 13.23 17.6938 12.6841 17.6938 12.0049Z","fill":"#8B929A"}));
}

More.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = More;

More.default = More;
